import DOMPurify from "dompurify";

export const sanitizeReleaseNoteHtml = (content: string): string => {
  if (!content || !content.trim()) return "";

  return DOMPurify.sanitize(content, {
    ADD_ATTR: ["style", "target", "rel"],
  });
};
